


<template>
  <div>
    <div class="col-12  pt-5 mt-3 text-end" v-if="data.isFrist">
      <button @click="next()" type="button" class="btn btn-primary btn-lg"
        :style="{ backgroundColor: color, borderColor: color }">
        {{ language == "cn" ? "下一步" : "Next" }}
      </button>
    </div>
    <div class="col-12  pt-5 mt-3 text-start" v-else-if="data.isLast">
      <span ref="pre" @mouseover="btnHover()" @mouseout="btnOut()" :style="{
        color: color,
        borderColor: color,
      }" @click="back()" class="btn btn-lg btn-outline-primary">{{ language == "cn" ? "上一步" : "Back" }}</span>
    </div>

    <div class="col-12  pt-5 mt-3 d-flex justify-content-between" v-else>
      <span ref="pre" @mouseover="btnHover()" @mouseout="btnOut()" :style="{
        color: color,
        borderColor: color,
      }" @click="back()" class="btn btn-lg btn-outline-primary">{{ language == "cn" ? "上一步" : "Back" }}</span>

      <button @click="next()" type="button" class="btn btn-primary btn-lg"
        :style="{ backgroundColor: color, borderColor: color }">
        {{ language == "cn" ? "下一步" : "Next" }}
      </button>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
  props: ["backSave", "nextSave"],

  computed: {
    ...mapState([
      // 映射 this.count 为 store.state.count
      'color'
    ]),
  },

  data() {
    return {
      language: sessionStorage.getItem("language") || "cn",
      menuData: [],
      data: {},
    };
  },
  created() {
    this.menuData = JSON.parse(sessionStorage.getItem("menuData"));
    this.menuData.forEach((item, index) => {
      if (item.path == this.$route.name) {
        this.data = item;
      }
    });
  },
  mounted() {
  },
  methods: {
    btnHover() {
      this.$refs.pre.style.backgroundColor = this.color;
      this.$refs.pre.style.color = "#fff";
    },
    btnOut() {
      this.$refs.pre.style.backgroundColor = "#fff";
      this.$refs.pre.style.color = this.color;
    },
    next() {
      this.$emit("nextSave");
    },
    back() {
      this.$emit("backSave");
    },
    async nextClick() {
      if (!this.data.nextPath) {
        return;
      }
      console.log(sessionStorage.getItem("userId"))
      setTimeout(() => {
        this.$router.push({
          name: this.data.nextPath,
          query: {
            projectId: sessionStorage.getItem("projectId"),
            userId: sessionStorage.getItem("userId")
          },
        });
      }, 1000);
    },
    backClick() {
      if (!this.data.prePath) {
        return;
      }
      this.$router.push({
        name: this.data.prePath,
        query: {
          projectId: sessionStorage.getItem("projectId"),
        },
      });
    },
  },
};
</script>

<style scoped></style>
